<template>
  <div :class="[isSingle ? 'container--article' : 'container--button']">
    <button class="btn btn--secondary black-button black-button--mobile" 
            id="ctaButton"
            @click="showModal() ,triggerGA()">
      {{ buttonLabel }}
      <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 20 14" aria-hidden="true">
        <path fill="#fff" fill-rule="evenodd" d="M6.646 3.646a.5.5 0 01.708 0l6 6a.5.5 0 010 .708l-6 6a.5.5 0 01-.708-.708L12.293 10 6.646 4.354a.5.5 0 010-.708z" />
      </svg>
    </button>
  </div>
</template>

<script>
  import { eventBus } from "@Foundation/eventbus/eventbus";

  export default {

    name: 'channel-advisor-cta-button',

    props: {
      channelAdvisorUrl: { type: String, required: true },
      buttonLabel: { type: String, default: 'shop here' },
      brandCode: { required: true },
      type: { required: true },
      variantId: { required: true },
      isSingle: { type: Boolean, default: false }
    },
    
    methods: {
      triggerGA() {
        let eventData = {
          event: 'uaevent',
          eventCategory: 'Ecommerce',
          eventAction: 'click to buy',
          eventLabel:this.buttonLabel,
          ecommerce: 'undefined'
        }
        window.dataLayer.push(eventData)
      },

      showModal() {
        const channelAdviserUrl = this.channelAdvisorUrl + '?pid=' + this.brandCode + '&model=' + this.variantId + '&type=' + this.type;
        eventBus.$emit('show-wsf-modal', channelAdviserUrl);
        window.addEventListener("message", this.channeltagging);
      },

      channeltagging(event) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }
</script>
<style lang="scss" src="./channel-advisor.scss"></style>

